/**
 * Commerce7 Module
 *
 * This module handles Commerce7 related functionality
 */

const Commerce7 = {
  observer: null,
  initialized: false,

  /**
   * Initialize the Commerce7 module functionality
   */
  init: function () {
    console.log('Commerce7 module initialized');

    if (this.initialized) {
      console.log('Commerce7 already initialized, skipping duplicate initialization');
      return;
    }

    // Watch for Commerce7 script load events
    this.setupScriptLoadMonitor();

    // Setup mutation observer to detect when C7 elements are added to the DOM
    this.setupMutationObserver();

    // Handle dynamic classes for Commerce7 collections
    this.handleCollectionClasses();

    // Add a listener for when Commerce7 collections are loaded
    document.addEventListener('c7-loaded', function () {
      console.log('C7 loaded event detected');
      Commerce7.handleCollectionClasses();
    });

    // Listen for Barba.js transitions to reinitialize Commerce7 widgets
    document.addEventListener('c7-barba-transition', () => {
      console.log('Barba transition detected, reinitializing Commerce7');

      // Force Commerce7 to re-render by clearing initialized flag
      this.initialized = false;

      // Handle collection classes
      setTimeout(() => {
        this.handleCollectionClasses();

        // If window.c7 object exists, try to trigger widgets refresh
        if (window.c7 && typeof window.c7.widgets === 'object') {
          // Refresh all Commerce7 widgets
          Object.keys(window.c7.widgets).forEach((widgetName) => {
            const widget = window.c7.widgets[widgetName];
            if (widget && typeof widget.render === 'function') {
              console.log(`Refreshing Commerce7 widget: ${widgetName}`);
              widget.render();
            }
          });
        }
      }, 100);
    });

    // Handle click events on wine offerings to ensure proper active classes
    if (typeof jQuery !== 'undefined') {
      jQuery(document).on('click', '.wine-offering', function () {
        console.log('Wine offering clicked, syncing active states');
        Commerce7.syncActiveStates();
      });
    }

    this.initialized = true;
  },

  /**
   * Set up monitoring for Commerce7 script load/reload
   * This helps ensure widgets are initialized properly after script is reloaded
   */
  setupScriptLoadMonitor: function () {
    // Create a MutationObserver to watch for script being added to the page
    const scriptObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (
              node.nodeType === 1 &&
              node.tagName === 'SCRIPT' &&
              (node.id === 'c7-javascript' || node.src.includes('commerce7.js'))
            ) {
              console.log('Commerce7 script detected - waiting for load');

              // Wait for script to load
              node.addEventListener('load', () => {
                console.log('Commerce7 script loaded - reinitializing collections');

                // Reset initialization and wait a moment for script to initialize
                this.initialized = false;

                // Give the script time to initialize the window.c7 object
                setTimeout(() => {
                  // Process any collections already in the DOM
                  this.handleCollectionClasses();

                  // Force any widgets to render
                  if (window.c7 && typeof window.c7.widgets === 'object') {
                    Object.keys(window.c7.widgets).forEach((widgetName) => {
                      const widget = window.c7.widgets[widgetName];
                      if (widget && typeof widget.render === 'function') {
                        console.log(`Rendering widget after script load: ${widgetName}`);
                        widget.render();
                      }
                    });
                  }
                }, 300);
              });
            }
          });
        }
      });
    });

    // Start observing
    scriptObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  },

  /**
   * Refresh all Commerce7 widgets manually
   * Can be called after dynamic page updates or Barba transitions
   */
  refreshWidgets: function () {
    console.log('Manually refreshing Commerce7 widgets');

    // Reset initialized flag
    this.initialized = false;

    // Re-run initialization
    this.init();

    // If window.c7 object exists from the Commerce7 CDN script
    if (window.c7) {
      // Try to use the native refresh method if available
      if (typeof window.c7.refresh === 'function') {
        console.log('Calling c7.refresh()');
        window.c7.refresh();
      }

      // Also refresh individual widgets if available
      if (typeof window.c7.widgets === 'object') {
        Object.keys(window.c7.widgets).forEach((widgetName) => {
          const widget = window.c7.widgets[widgetName];
          if (widget && typeof widget.render === 'function') {
            console.log(`Refreshing widget: ${widgetName}`);
            widget.render();
          }
        });
      }
    }

    // Find all Commerce7 widget containers and add a special class
    // This helps to notify observers that widgets have been refreshed
    const c7Elements = document.querySelectorAll('[id^="c7-"]');
    c7Elements.forEach((el) => {
      el.classList.add('c7-refreshed');
      // Remove the class after a brief delay to allow for animations
      setTimeout(() => {
        el.classList.remove('c7-refreshed');
      }, 50);
    });

    // Dispatch event to notify components that c7 has been refreshed
    document.dispatchEvent(new CustomEvent('c7-refreshed'));
  },

  /**
   * Set up a mutation observer to watch for Commerce7 elements being added to the DOM
   */
  setupMutationObserver: function () {
    // Check if we already have an observer
    if (this.observer) {
      this.observer.disconnect();
    }

    // Create a new observer
    this.observer = new MutationObserver((mutations) => {
      let shouldProcessC7Elements = false;

      // Check if any relevant nodes were added
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              // Element node
              // Check if the added node is a C7 element or contains one
              if (
                node.classList &&
                (node.classList.contains('c7-product-collection') ||
                  node.classList.contains('c7-product-collection__product-list') ||
                  node.querySelector('.c7-product-collection__product-list'))
              ) {
                shouldProcessC7Elements = true;
              }
            }
          });
        }
      });

      // If relevant nodes were added, process them
      if (shouldProcessC7Elements) {
        //  console.log('C7 elements detected, processing...');
        this.handleCollectionClasses();
        // Wait a brief moment to ensure all C7 elements are properly rendered
        setTimeout(() => {
          this.cleanUpExistingSlick();
          this.initializeC7ProductLists();
        }, 200);
      }
    });

    // Start observing the document body
    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    console.log('Commerce7 mutation observer set up');
  },

  /**
   * Clean up any existing slick initializations on or inside C7 collections
   */
  cleanUpExistingSlick: function () {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick === 'function') {
      // Check for slick-initialized divs that contain or are inside C7 collections
      const $slickDivs = jQuery('.slick-initialized').filter(function () {
        // Either this element is a C7 element
        const isC7Element = jQuery(this).hasClass('c7-product-collection__product-list');
        // Or this element contains a C7 element
        const containsC7 = jQuery(this).find('.c7-product-collection').length > 0;
        // Or this element is inside a wrapper with a C7 element but is not the product list
        const insideC7 =
          jQuery(this).closest('.wine-content').find('.c7-product-collection').length > 0 &&
          !jQuery(this).hasClass('c7-product-collection__product-list');

        return isC7Element || containsC7 || insideC7;
      });

      if ($slickDivs.length) {
        console.log(
          `Found ${$slickDivs.length} slick-initialized elements related to C7, cleaning up...`
        );

        $slickDivs.each(function () {
          const $this = jQuery(this);

          // If it's not the actual product list but contains it, we should uninitialize it
          if (
            !$this.hasClass('c7-product-collection__product-list') &&
            ($this.find('.c7-product-collection__product-list').length > 0 ||
              $this.closest('.wine-content').find('.c7-product-collection__product-list').length >
                0)
          ) {
            try {
              console.log(`Unslicking wrapper element: ${$this.attr('class')}`);
              $this.slick('unslick');
            } catch (e) {
              console.error('Error unslicking wrapper element:', e);
            }
          }
        });
      }
    }
  },

  /**
   * Initialize slick on all C7 product lists
   */
  initializeC7ProductLists: function () {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick === 'function') {
      // Find all C7 product lists that aren't already slick-initialized
      const $productLists = jQuery('.c7-product-collection__product-list').not(
        '.slick-initialized'
      );

      if ($productLists.length) {
        console
          .log
          //  `Found ${$productLists.length} uninitialized C7 product lists, initializing slick...`
          ();

        $productLists.each(function () {
          const $list = jQuery(this);
          const $wineContent = $list.closest('.wine-content');

          // Check if the product list has wine items
          if ($list.find('.wine-single-cart-container').length === 0) {
            //  console.log('No wine items found in product list, skipping slick initialization');
            return;
          }

          try {
            // Make sure no parent elements are slick-initialized
            const $slickParents = $list.parents('.slick-initialized');
            if ($slickParents.length) {
              console.log('Found slick-initialized parent, attempting to unslick first');
              $slickParents.each(function () {
                try {
                  jQuery(this).slick('unslick');
                  console.log('Unslicked parent element');
                } catch (e) {
                  console.error('Error unslicking parent element:', e);
                }
              });
            }

            // Now initialize slick on the product list
            $list.slick({
              dots: false,
              infinite: true,
              autoplay: false,
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: false,
              variableWidth: false,
              prevArrow: $wineContent.find('.left-arrow'),
              nextArrow: $wineContent.find('.right-arrow'),
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    variableWidth: true,
                  },
                },
              ],
            });
            console.log(`Initialized slick on C7 product list in ${$wineContent.attr('class')}`);
          } catch (e) {
            console.error('Error initializing slick on C7 product list:', e);
          }
        });
      }
    }
  },

  /**
   * Apply the correct classes to Commerce7 collections
   */
  handleCollectionClasses: function () {
    // Find all Commerce7 collection containers
    const collections = document.querySelectorAll('.c7-product-collection');

    if (collections.length) {
      // console.log('Found ' + collections.length + ' Commerce7 collections');

      collections.forEach(function (collection) {
        // Get the parent wine-content element
        const wineContent = collection.closest('.wine-content');

        if (wineContent) {
          // Get the class from the data attribute
          const tabClass = collection.getAttribute('data-tab-class');

          // Also check for collection slug attribute
          const collectionSlug = collection.getAttribute('data-collection-slug');

          // Apply the class from data-tab-class attribute if available
          if (tabClass && !wineContent.classList.contains(tabClass)) {
            console.log('Adding class ' + tabClass + ' to wine-content');
            wineContent.classList.add(tabClass);
          }

          // If there's no tab class but there is a collection slug, use that for the class
          if (!tabClass && collectionSlug && !wineContent.classList.contains(collectionSlug)) {
            console.log('Adding collection slug class ' + collectionSlug + ' to wine-content');
            wineContent.classList.add(collectionSlug);
          }

          // If this collection is not already rendered and has a slug, it might need loading
          if (collectionSlug && collection.children.length === 0) {
            console.log(
              'Found empty collection with slug: ' + collectionSlug + ', might need initialization'
            );
            // Flag this collection for initialization by Commerce7
            collection.setAttribute('data-needs-init', 'true');

            // If the collection has the "slider-collection" class, make sure we handle it properly
            if (collection.classList.contains('slider-collection')) {
              collection.classList.add('c7-pending-slider');
            }
          }
        }
      });

      // Clean up any existing slick initializations
      this.cleanUpExistingSlick();

      // Process product lists after adding classes
      this.initializeC7ProductLists();

      // Sync active states after adding classes
      this.syncActiveStates();

      // If window.c7 exists, try to force rendering of collections
      if (window.c7 && typeof window.c7.widgets === 'object' && window.c7.widgets.collection) {
        const collectionsToRender = document.querySelectorAll('[data-needs-init="true"]');
        if (collectionsToRender.length > 0) {
          console.log(`Found ${collectionsToRender.length} collections that need initialization`);

          collectionsToRender.forEach((collection) => {
            const slug = collection.getAttribute('data-collection-slug');
            if (slug) {
              console.log(`Forcing render of collection: ${slug}`);

              // Remove the initialization flag
              collection.removeAttribute('data-needs-init');

              // Try to force the collection to render
              if (typeof window.c7.collection === 'function') {
                try {
                  window.c7.collection({
                    el: collection,
                    slug: slug,
                  });
                } catch (e) {
                  console.error(`Error rendering collection ${slug}:`, e);
                }
              }
            }
          });

          // Check again for sliders after collections render
          setTimeout(() => {
            this.cleanUpExistingSlick();
            this.initializeC7ProductLists();
          }, 500);
        }
      }
    }
  },

  /**
   * Ensure that active wine-content divs match active wine-offering divs
   */
  syncActiveStates: function () {
    if (typeof jQuery !== 'undefined') {
      // Wait a brief moment to ensure all DOM changes are complete
      setTimeout(() => {
        // Get the active wine offering class
        const activeOffering = jQuery('.wine-offering.active');
        if (activeOffering.length) {
          // Extract the class that isn't 'wine-offering' or 'active'
          let activeClass = '';
          activeOffering
            .attr('class')
            .split(' ')
            .forEach(function (cls) {
              if (cls !== 'wine-offering' && cls !== 'active') {
                activeClass = cls;
              }
            });

          if (activeClass) {
            console.log('Syncing active state for', activeClass);

            // Remove active class from all wine-content divs
            jQuery('.wine-content').removeClass('active');

            // Add active class to the matching wine-content div
            const $activeContent = jQuery('.wine-content.' + activeClass);
            $activeContent.addClass('active');

            // Clean up any double-initialized slick sliders
            this.cleanUpExistingSlick();

            // Find the product list element and ensure it has slick initialized
            const $c7List = $activeContent.find('.c7-product-collection__product-list');
            if ($c7List.length) {
              if (!$c7List.hasClass('slick-initialized') && typeof jQuery.fn.slick === 'function') {
                // Initialize slick if it's not already initialized
                console.log('Initializing slick for', activeClass);
                $c7List.slick({
                  dots: false,
                  infinite: true,
                  autoplay: false,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  centerMode: false,
                  variableWidth: false,
                  prevArrow: $activeContent.find('.left-arrow'),
                  nextArrow: $activeContent.find('.right-arrow'),
                  responsive: [
                    {
                      breakpoint: 767,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        variableWidth: true,
                      },
                    },
                  ],
                });
              } else if ($c7List.hasClass('slick-initialized')) {
                // If already initialized, refresh the slider
                try {
                  $c7List.slick('setPosition');
                  console.log('Refreshed slick position for', activeClass);
                } catch (e) {
                  console.error('Error refreshing slick slider:', e);
                }
              }
            }
          }
        }
      }, 100);
    }
  },
};

export default Commerce7;
